import React, { useRef, useState } from "react";
import {FaRetweet} from "react-icons/fa";
import {NumberFormat} from "../../Helper/NumberFormat";


export const Card = ({
                         lang = "en",
                         colorPrimary = "#000000",
                         colorSecondary = "#000000",
                         colorFont = "#FFFFFF",
                         cardImage = "",
                         fontFamily = "Arial",
                         brand = "VISA",
                         showBalance = "N",
                        balance = 0.00,
                         brandPosition = "top-right",
                         nfc = "Y",
                         nfcPosition = "bottom-left",
                         allowFlip = "Y",
                         bankName = "",
                         bankLogo = "",
                         bankLogoPosition = "top-right",
                         cardNumber = "1234 5678 9012 3456",
                         cardHolder = "CARDHOLDER NAME",
                         expires = "12/34",
                         cvv = "123",
                         width = "100vw",
                         height = "100vh",
                         shape= '',
                         hiddenData = "N",
                         buttonFlip = "",
                         cuentaId = null
                     }) => {
    const [flipped, setFlipped] = useState(false);
    const divRef = useRef(null);

    const handleFlip = () => {
        if (allowFlip === "N") return;
        setFlipped(!flipped);
    };

    return (
        <div
            className="bg-transparent"
            style={{
                width: width,
                height: height,
            }}
        >
            <div
                className="relative mb-10 w-full h-full"
                style={{ perspective: "1000px" }}
            >
                <div className={`relative w-full h-full transition-transform duration-700 ${flipped ? "rotate-y-180" : ""}`}
                     style={{transformStyle: "preserve-3d", transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",}}
                     id={"cardContainer"}
                     onClick={(event) => {
                         event.preventDefault();
                         console.log("vtOnClick", { vtCuentaId: cuentaId });
                         window.VTWidgetBridge?.Bridge.raiseEvent?.("vtOnClick", {
                             vtCuentaId: cuentaId,
                         });
                     }}>

                    {/* FRONT */}
                    <div
                        ref={divRef}
                        id={"cardFront"}
                        style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundImage:
                                cardImage !== ""
                                    ? `url(${cardImage})`
                                    : colorSecondary !== ""
                                        ? `linear-gradient(45deg, ${colorPrimary}, ${colorSecondary})`
                                        : colorPrimary,
                            backgroundSize: cardImage !== "" ? "cover" : "initial",
                            backgroundPosition: cardImage !== "" ? "center" : "initial",
                            borderRadius: "0.75rem",
                            boxShadow:
                                `-15px -15px 10px -5px ${colorPrimary}26`,
                            color: colorFont,
                            padding: "0.75rem 1.25rem",
                            backfaceVisibility: "hidden",
                        }}>

                        <h3 id={'bankNameLabel'} className="text-xl mb-4">{bankName.toUpperCase()}</h3>

                        <div id={'brandContainer'} className="flex justify-between items-center">

                            <span id={'cardNumberLabel'} className="text-xl font-bold tracking-widest" style={{fontFamily: fontFamily, zIndex:999}}> {hiddenData==="Y" ? "**** **** **** " + cardNumber.slice(-4) : cardNumber}</span>

                            {(showBalance === "Y") && (
                                <span className="font-semibold text-lg" style={{fontFamily: fontFamily, zIndex: 10}}>$ {NumberFormat(balance,2,",",".")}</span>
                            )}

                            {/* BRAND */}
                            {(brandPosition === "top-right" ||
                                brandPosition === "top-left" ||
                                brandPosition === "bottom-right" ||
                                brandPosition === "bottom-left") && (
                                <div
                                    id={'brandLogo'}
                                    style={{
                                        position: "absolute",
                                        ...(brandPosition.includes("top") && {top: 8}),
                                        ...(brandPosition.includes("bottom") && {bottom: 10}),
                                        ...(brandPosition.includes("left") && {left: 10}),
                                        ...(brandPosition.includes("right") && {right: 10}),
                                    }}
                                >
                                    {brand.toUpperCase() === "MASTER" && (
                                        <img
                                            id={'logoMaster'}
                                            style={{objectFit: "contain"}}
                                            className="w-10"
                                            src="/logo_mastercard.png"
                                            alt="Master"
                                        />
                                    )}

                                    {brand.toUpperCase() === "VISA" && (
                                        <img
                                            id={'logoVisa'}
                                            style={{objectFit: "contain"}}
                                            className="w-10" src="/logo_visa.png" alt="Visa"/>
                                    )}
                                </div>
                            )}

                            {/* NFC */}
                            {(nfcPosition === "top-right" ||
                                nfcPosition === "top-left" ||
                                nfcPosition === "bottom-right" ||
                                nfcPosition === "bottom-left") && (
                                <div
                                    id={'nfcLogo'}
                                    style={{
                                        position: "absolute",
                                        ...(nfcPosition.includes("top") && {top: 15}),
                                        ...(nfcPosition.includes("bottom") && {bottom: 15}),
                                        ...(nfcPosition.includes("left") && {left: 15}),
                                        ...(nfcPosition.includes("right") && {right: 15}),
                                    }}
                                >
                                    {nfc.toUpperCase() === "Y" && (
                                        <img
                                            id={'logoNFC'}
                                            className="w-3"
                                            src="/NFC.png"
                                        />
                                    )}
                                </div>
                            )}


                            {(nfcPosition === "top-right" ||
                                nfcPosition === "top-left" ||
                                nfcPosition === "bottom-right" ||
                                nfcPosition === "bottom-left") && (
                                <div
                                    id={'balanceText'}
                                    style={{
                                        position: "absolute",
                                        fontSize: "0.75rem",
                                        fontWeight: "bold",
                                        fontFamily: fontFamily,
                                        color: colorFont,
                                        ...(nfcPosition.includes("top") && {top: 35}),
                                        ...(nfcPosition.includes("bottom") && {bottom: 35}),
                                        ...(nfcPosition.includes("left") && {left: 15}),
                                        ...(nfcPosition.includes("right") && {right: 15}),
                                    }}
                                >

                                </div>
                            )}




                        {shape === "ELIPSIS" && (
                                <div
                                    id={'shapeCardContainer'}
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "70%",
                                        left: 0,
                                        bottom: 0,
                                        overflow: "hidden",
                                        borderRadius: "0.75rem",
                                        zIndex: 1, // 👈 importante
                                    }}
                                >
                                    <div
                                        id={'shapeCard'}
                                        style={{
                                            position: "absolute",
                                            bottom: -50,
                                            left: -70,
                                            width: "150%",
                                            height: "120%",
                                        }}
                                    >
                                        <img id={'shapeCardImage'} src="/shape_card.png" alt="Shape" />
                                    </div>
                                </div>
                            )}


                            {/* BANK LOGO */}
                            {bankLogo && (
                                <div
                                    id={'bankLogo'}
                                    style={{
                                        width: '40%',
                                        height: '20%',
                                        position: "absolute",
                                        zIndex: 9999,
                                        ...(bankLogoPosition.includes("top") && {top: 5}),
                                        ...(bankLogoPosition.includes("bottom") && {bottom: 5}),
                                        ...(bankLogoPosition.includes("left") && {left: 5}),
                                        ...(bankLogoPosition.includes("right") && {right: 5}),
                                    }}
                                >
                                    <img
                                        id={'bankLogoImage'}
                                        style={{objectFit: "contain",width:'100%', height:'100%'}}
                                        src={bankLogo}
                                        alt="BankLogo"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="mt-4" style={{zIndex:9999}}>
                            {lang === "en" && <span>Card holder</span>}
                            {lang === "es" && <span>Titular</span>}
                            {lang === "pt" && <span>Titular do cartão</span>}
                            <br/>
                            <span className="font-semibold text-lg" style={{fontFamily: fontFamily,zIndex:10}}> {cardHolder}</span>
                        </div>

                        {buttonFlip !== "" && buttonFlip !== "NONE" && (
                            <div
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleFlip();
                                }}
                                style={{
                                    position: "absolute",
                                    width: 50,
                                    height: 50,
                                    left: -25,
                                    bottom: 30,
                                    borderRadius: 100,
                                    zIndex: 1000,
                                    backgroundColor: buttonFlip,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <FaRetweet
                                    size={35}
                                    style={{
                                        color: buttonFlip === "#000000" ? "#FFFFFF" : "#000000",
                                    }}
                                />
                            </div>
                        )}

                    </div>

                    {/* BACK */}
                    <div
                        className="absolute w-full h-full bg-black rounded-xl shadow-xl text-gray-300 px-5 py-3"
                        id={"cardBack"}
                        style={{
                            backgroundColor:
                                colorSecondary !== "" ? colorSecondary : "#000000",
                            backfaceVisibility: "hidden",
                            transform: "rotateY(180deg)",
                        }}
                    >
                        <h3 className="text-xl mb-4">
                            {lang === "en" && <span>Security Code</span>}
                            {lang === "es" && <span>Código de Seguridad</span>}
                            {lang === "pt" && <span>Código de segurança</span>}
                            {lang === "de" && <span>Sicherheitscode</span>}
                            {lang === "fr" && <span>Code de sécurité</span>}
                            {lang === "it" && <span>Codice di sicurezza</span>}
                        </h3>
                        <div className="relative mt-2">
                            <div className="bg-gray-700 h-10 w-full rounded-md"></div>
                            <div className="mt-4 text-sm">
                                <span className="block text-right">
                                  {lang === "en" && (<span>For security purposes, do not share this code.</span>)}
                                    {lang === "es" && (<span>Por motivos de seguridad, no comparta este código.</span>)}
                                    {lang === "pt" && (<span>Por motivos de segurança, não compartilhe este código.</span>)}
                                    {lang === "de" && (<span>Aus Sicherheitsgründen geben Sie diesen Code nicht weiter.</span>)}
                                    {lang === "fr" && (<span>Pour des raisons de sécurité, ne partagez pas ce code.</span>)}
                                    {lang === "it" && (<span>Per motivi di sicurezza, non condividere questo codice.</span>)}
                                </span>
                            </div>
                            <span className="absolute top-2 right-4 text-white font-semibold">{cvv}</span>
                        </div>
                        <div className="mt-12">
                              <span  style={{ fontFamily: fontFamily }}>
                                {lang === "en" && <span>Expires:</span>}
                                  {lang === "es" && <span>Expiración:</span>}
                                  {lang === "pt" && <span>Expira:</span>}
                                  {lang === "de" && <span>Ablaufdatum:</span>}
                                  {lang === "fr" && <span>Date d'expiration:</span>}
                                  {lang === "it" && <span>Scadenza:</span>}
                              </span>
                            <span>{expires}</span>
                        </div>
                        <div className="absolute bottom-6 right-6">
                            {brand.toUpperCase() === "MASTER" && (
                                <img className="w-12" src="/logo_mastercard.png" alt="Master" />
                            )}
                            {brand.toUpperCase() === "VISA" && (
                                <img className="w-12" src="/logo_visa.png" alt="Visa" />
                            )}
                        </div>

                        {buttonFlip !== "" && buttonFlip !== "NONE" && (
                            <div
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleFlip();
                                }}
                                style={{
                                    position: "absolute",
                                    width: 50,
                                    height: 50,
                                    left: -25,
                                    bottom: 30,
                                    borderRadius: 100,
                                    zIndex: 1000,
                                    backgroundColor: buttonFlip,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <FaRetweet
                                    size={35}
                                    style={{
                                        color: buttonFlip === "#000000" ? "#FFFFFF" : "#000000",
                                    }}
                                />
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};
